/**
 * built-in events for element
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationEvent
 *
 * TODO: use MutationObserver instead
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 */
export var ElementEvent;

(function (ElementEvent) {
  ElementEvent["DESTROY"] = "destroy";
  /**
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-type-DOMAttrModified
   */

  ElementEvent["ATTR_MODIFIED"] = "DOMAttrModified";
  /**
   * it has been inserted
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-type-DOMNodeInserted
   */

  ElementEvent["INSERTED"] = "DOMNodeInserted";
  /**
   * it has had a child inserted
   */

  ElementEvent["CHILD_INSERTED"] = "child-inserted";
  /**
   * it is being removed
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-type-DOMNodeRemoved
   */

  ElementEvent["REMOVED"] = "removed";
  /**
   * it has had a child removed
   */

  ElementEvent["CHILD_REMOVED"] = "child-removed";
  /**
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#domnodeinsertedintodocument
   */

  ElementEvent["MOUNTED"] = "DOMNodeInsertedIntoDocument";
  /**
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#domnoderemovedfromdocument
   */

  ElementEvent["UNMOUNTED"] = "DOMNodeRemovedFromDocument";
  ElementEvent["BOUNDS_CHANGED"] = "bounds-changed";
  /**
   * trigger when z-index changed
   */

  ElementEvent["RENDER_ORDER_CHANGED"] = "render-order-changed";
})(ElementEvent || (ElementEvent = {}));